
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/hot-deals",
      function () {
        return require("private-next-pages/collections/hot-deals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/hot-deals"])
      });
    }
  